import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Alert } from '../components/Alert'

export const makePDF = async (documentId, fileName, ignoreElementItems) => {

  const input = document.getElementById(documentId)
  const orientation = input.clientWidth > input.clientHeight ? 'landscape' : 'portrait'

  await html2canvas(input,  {
      logging: false,
      ignoreElements: (element) => ignoreElementItems.includes(element.id)
    }).then(canvas => {
    const imgData = canvas.toDataURL('image/png')
    const doc = new jsPDF(orientation, 'px', [canvas.width, canvas.height])
    doc.addImage(imgData, 'JPEG', 0, 0, canvas.width, canvas.height, undefined, 'FAST');
    doc.save(`${fileName}.pdf`)
  }).catch(e => {
    Alert.error('Export to PDF unsuccessfully')
  })
}
